import React from "react";
import { ShieldAlert, RefreshCw } from "lucide-react";

interface AccessDeniedProps {
  message: string;
  onRetry?: () => void;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ message, onRetry }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        margin: "24px 0",
        backgroundColor: "#FFF5F5",
        border: "1px solid #FEB2B2",
        borderRadius: "12px",
        textAlign: "center",
        fontFamily: "Inter, sans-serif",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",
        maxWidth: "600px",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          backgroundColor: "#FED7D7",
          color: "#C53030",
          marginBottom: "16px",
        }}
      >
        <ShieldAlert size={28} />
      </div>
      <h3
        style={{
          fontSize: "18px",
          fontWeight: 600,
          color: "#9B2C2C",
          marginBottom: "8px",
          marginTop: 0,
        }}
      >
        Access Denied
      </h3>
      <p
        style={{
          fontSize: "14px",
          color: "#742A2A",
          lineHeight: "1.5",
          marginBottom: "20px",
          marginTop: 0,
          fontWeight: 500,
        }}
      >
        {message}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            backgroundColor: "#C53030",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#9B2C2C")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#C53030")}
        >
          <RefreshCw size={14} />
          Retry
        </button>
      )}
    </div>
  );
};

export default AccessDenied;
